import React, { useState } from "react";

import {
  SubHeader,
  Select,
  Textarea,
  Table,
  Pagination,
} from "clearsense-ui/components";
import KpiCard from "components/Common/KpiCard";

import {
  CDE_REVIEW_COLUMNS,
  TEMPORARY_CDE_REVIEW_REPORT_DATA,
  TABLE_PAGE_SIZE,
} from "./constants";

const CDEReviewReport = () => {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="px-8">
      <SubHeader
        breadcrumbs={[{ label: "CDE Review Report", link: "#" }]}
        className="p-8 pl-0"
      />
      <div className="flex gap-8">
        <Select
          isClearable
          label="Domain"
          name="domain"
          placeholder="Select a Domain"
          size="small"
        />
        <Select
          isClearable
          label="Data Source*"
          name="data_source"
          placeholder="Select a Data Source"
          size="small"
        />
        <Select
          isClearable
          label="Subdomain"
          name="subdomain"
          placeholder="Select a Subdomain"
          size="small"
        />
        <Select
          isClearable
          label="Critical Data Element*"
          name="critical_data_element"
          placeholder="Select a Critical Data Element"
          size="small"
        />
      </div>
      <div className="flex space-x-8 mt-8">
        <div className="space-y-8 w-1/2">
          <Textarea label="Critical Data Element Definition" rows={5} />
          <Textarea label="Source Mapping" rows={5} />
          <Textarea label="Load Rule(s)" rows={5} />
        </div>
        <div className="flex flex-col space-y-6 w-1/2">
          <div className="flex gap-10 justify-center w-full">
            <KpiCard label="Total Records" count={2600} />
            <KpiCard label="Distinct Records" count={1500} />
            <KpiCard label="% Null Values" count={`${23.2}%`} />
          </div>
          <div className="h-[calc(100vh-440px)]">
            <Table
              fixedHeight
              defaultPageSize={TABLE_PAGE_SIZE}
              currentPageNumber={currentPage}
              columnData={CDE_REVIEW_COLUMNS}
              rowData={TEMPORARY_CDE_REVIEW_REPORT_DATA}
            />
            <Pagination
              pageSize={TABLE_PAGE_SIZE}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecordsCount={TEMPORARY_CDE_REVIEW_REPORT_DATA.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CDEReviewReport;
